import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  ENTERPRISE_MODULE4_POST_CREATION_SOURCE_OPTIONS,
  ENTERPRISE_MODULE4_SCHEDULING_NETWORKS_OPTIONS,
} from "../../../../utils/constants";
import {
  ENTERPRISE_INTAKE_MODULE4_FIELD_MONTHLY_ORGANIC_POSTS,
  ENTERPRISE_INTAKE_MODULE4_FIELD_POST_CREATION_SOURCE,
  ENTERPRISE_INTAKE_MODULE4_FIELD_SCHEDULING_NETWORKS,
  ENTERPRISE_INTAKE_MODULE4_INTRO,
} from "../../../../i18n/keysTranslations";
import ReadOnlySectionGrid from "../../../PreActivation/components/ReadOnlySectionGrid";
import CheckboxGroupWithOtherField from "../shared/CheckboxGroupWithOtherField";
import ModuleSectionIntro from "../shared/ModuleSectionIntro";
import NumericFieldBlock from "../shared/NumericFieldBlock";
import RadioWithOtherField from "../shared/RadioWithOtherField";
import { mapTranslatedOptions } from "../shared/mapTranslatedOptions";

const Module4OrganicSocialSection = ({ control, errors, readOnly }) => {
  const { t } = useTranslation();

  const schedulingNetworkOptions = useMemo(
    () =>
      mapTranslatedOptions({
        options: ENTERPRISE_MODULE4_SCHEDULING_NETWORKS_OPTIONS,
        t,
      }),
    [t]
  );

  const postCreationSourceOptions = useMemo(
    () =>
      mapTranslatedOptions({
        options: ENTERPRISE_MODULE4_POST_CREATION_SOURCE_OPTIONS,
        t,
      }),
    [t]
  );

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      {!readOnly ? (
        <ModuleSectionIntro introKey={ENTERPRISE_INTAKE_MODULE4_INTRO} />
      ) : null}

      <NumericFieldBlock
        name="module4MonthlyOrganicPostsCount"
        labelKey={ENTERPRISE_INTAKE_MODULE4_FIELD_MONTHLY_ORGANIC_POSTS}
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />

      <CheckboxGroupWithOtherField
        name="module4SchedulingNetworks"
        otherName="module4SchedulingNetworksOther"
        labelKey={ENTERPRISE_INTAKE_MODULE4_FIELD_SCHEDULING_NETWORKS}
        required
        options={schedulingNetworkOptions}
        control={control}
        errors={errors}
        readOnly={readOnly}
      />

      <RadioWithOtherField
        name="module4PostCreationSource"
        labelKey={ENTERPRISE_INTAKE_MODULE4_FIELD_POST_CREATION_SOURCE}
        required
        options={postCreationSourceOptions}
        control={control}
        errors={errors}
        readOnly={readOnly}
      />
    </ReadOnlySectionGrid>
  );
};

export default Module4OrganicSocialSection;
